import { FC } from "react";

import { t } from "i18n/i18n";
import { Tooltip } from "mds/components/Tooltip";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useHomeUrl } from "utils/hooks/use-home-url";
import { useNavigate } from "utils/routing";
import { useViewLevel } from "utils/urls";

export const HomeButton: FC<{
  className?: string;
  disabled?: boolean;
  disabledTooltipText?: string;
  openInNewTab?: boolean;
}> = ({ className, disabled, disabledTooltipText, openInNewTab }) => {
  const navigate = useNavigate();
  const viewLevel = useViewLevel();
  const isHomePage = viewLevel.home;
  const readOnly = isHomePage;
  const homeUrl = useHomeUrl();

  return (
    <Tooltip content={disabled ? disabledTooltipText : ""}>
      <SquareButton
        className={className}
        disabled={disabled}
        eventName="Go to Home"
        kind="ghost"
        size="s"
        onClick={() => {
          if (!disabled && !readOnly) {
            if (openInNewTab) {
              window.open(homeUrl, "_blank", "noopener");
            } else {
              navigate(homeUrl);
            }
          }
        }}
      >
        {t("main_header.home")}
      </SquareButton>
    </Tooltip>
  );
};
